/* unplugin-vue-components disabled */import { render } from "./MicroHeadlinesDetails.vue?vue&type=template&id=53d66838&scoped=true"
import script from "./MicroHeadlinesDetails.vue?vue&type=script&lang=js"
export * from "./MicroHeadlinesDetails.vue?vue&type=script&lang=js"

import "./MicroHeadlinesDetails.vue?vue&type=style&index=0&id=53d66838&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d66838"]])

export default __exports__